document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('slideshow-component').forEach(function (component) {
    const slider = component.querySelector('.slider');
    if (!slider) return;

    const slides = Array.from(component.querySelectorAll('.slider__slide'));
    if (slides.length <= 1) return;

    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed || '5', 10) * 1000;

    let current = 0;
    let interval = null;

    function goToSlide(index) {
      current = (index + slides.length) % slides.length;
      const slideWidth = slides[0].offsetWidth;
      slider.scrollTo({ left: slideWidth * current, behavior: 'smooth' });
    }

    if (autoplay) {
      interval = setInterval(function () {
        goToSlide(current + 1);
      }, speed);
    }

    const prevBtn = component.querySelector('.slider-button--prev');
    const nextBtn = component.querySelector('.slider-button--next');

    if (prevBtn) prevBtn.addEventListener('click', function () {
      clearInterval(interval);
      goToSlide(current - 1);
      if (autoplay) interval = setInterval(function () { goToSlide(current + 1); }, speed);
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      clearInterval(interval);
      goToSlide(current + 1);
      if (autoplay) interval = setInterval(function () { goToSlide(current + 1); }, speed);
    });
  });
});
